const Strings = {
  Users: 'Users',
  Customers: 'Customers',
  userRolePermission: 'User Role Permission',
  rolePermission: 'Role Permission',
  orders: 'Orders',
  Save: 'Save',
  Submit: 'Submit',
  ExportUsers: 'Export Customers',
  ExportProducts: 'Export Products',
  ExportOrders: 'Export Orders',
  ExportProductMetal: 'Export Product Metal',
  ExportProductPurity: 'Export Product Purity',
  ExportManufactures: 'Export Manufactures',
  AddUsers: 'Add Customers',
  AddProducts: 'Add Products',
  AddProductMetal: 'Add Product Metal',
  AddProductPurity: 'Add Product Purity',
  AddManufactures: 'Add Manufactures',
  AddOrders: 'Add Orders',


  // dashboard Strings
  totalGoldSale: 'Total Gold Sale',
  totalSilverSale: 'Total Silver Sale',
  totalSalePcsRate: 'Total Sale Pcs Rate',
  productSold: "Product Sold",
  totalOrder: 'Total Order',
  completeOrder: 'Complete Order',
  pendingOrder: 'Pending Order',
  orderPipeline: 'Order Pipeline',
  newCustomers: "New Customers",
  repeatCustomers: 'Repeat Customers',
  newLogin: 'New Login',
  newSubscribe: 'New Subscribe',
  Dashboard: 'Dashboard',



  ConfirmDelete: 'Confirm Delete',
  checkboxText: 'Check this custom checkbox to confirm you’re not robot',
  PersonalInformation: 'Personal Information',
  ExportOptions:'Export Options',
  ExportExcel: ' Export to Excel',
  ExportPDF: '  Export to PDF',
  DoNotHaveAccount: 'Don’t have an account',
  NoDataFound: 'No Data Available',
  deleteProductConfirmation: 'Are you sure you want to delete this product?',
  deleteUserConfirmation: 'Are you sure you want to delete this user?',
  deleteManufacturerConfirmation: 'Are you sure you want to delete this Manufacturer?',
  deleteOrderConfirmation: 'Are you sure you want to delete this order?',
  deleteProductMetalConfirmation: 'Are you sure you want to delete this product Metal?',
  deleteProductPurityConfirmation: 'Are you sure you want to delete this product Purity?',
  logoutConfirmation: 'Are you sure you want to logout this user?',



  //validation errors
  productNameError: 'Product Name is required',
  categoryNameError: 'Product Category is required',
  metalNameRequiredError: 'Product Metal Name is required',
  purityRequiredError: 'Purity is required',
  descriptionRequiredError: 'Product Description is required',
  grossRequiredError: 'Product Gross Weight is required',
  lessRequiredError: 'Product Less Weight is required',
  netRequiredError: 'Net Weight is required',
  productCodeRequiredError: 'Product Code is required',
  quantityRequiredError: 'Product Quantity is required',
  quantityPositiveError: 'Quantity must be positive',
  quantityIntegerError: 'Product Quantity must be an integer',
  pricePositiveError: 'Price must be positive',
  priceRequiredError: 'Product Price is required',

  
  firstNameRequired: 'First Name is required',
  lastNameRequired: 'Last Name is required',
  userEmailRequired: 'User Email is required',
  userMobileNoRequired: 'User Mobile number is required',
  phoneNumberNumericError: 'Phone number must be numeric',
  phoneNumberLengthError: 'Phone number must be exactly 10 digits',
  userAddressRequired: 'User Address is required',


  productNameRequired: 'Product Metal Name is required',
  metalIdRequired: 'metal id is required',
  productValueRequired:'Product Metal Value is required',

  productcategoryNameRequired:"Product Category Name is required",
  // API Errors
  somethingWentWrongError: 'Something went wrong !',


  //Placeholder Strings
  mobileNoPlaceholder: 'Enter Mobile Number',


  // User Role Name
  Admin: 'admin',
  Manufactures: 'Manufacturer',
  Retailer: 'Retailer',


  // Logout title
  logoutTitle: "Do you want to Log Out ?",
  deleteTitle: 'Are you sure you want to delete ?'

  
}

export default Strings